module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [(_vm.appointmentIds) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n    " + _vm._s(_vm.$tc('title', _vm.appointmentIds.length, {
    count: _vm.appointmentIds.length
  })) + "\n    "), _c('v-spacer'), _vm._v(" "), (!_vm.showDetails) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.expand
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.more')))]) : _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDetails = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.less')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('v-card-text', [(_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "my-0",
    attrs: {
      "height": "3",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appointments) ? _c('v-list', {
    staticClass: "elevation-3",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('sleecteditems')))]), _vm._v(" "), _vm._l((_vm.appointments), function(appointment) {
    return _c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-action": false,
        "with-tags": true,
        "appointment": appointment
      }
    })
  })], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e389b30c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/SelectedAppointmentsPreview.vue
// module id = 1540
// module chunks = 9